/**
 * Picker-supplied titles are plaintext; HTML-escape before writing to titleHTML
 * (rendered via dangerouslySetInnerHTML). Server response overwrites with the
 * real rich HTML when the mutation resolves.
 */
export function escapeOptimisticTitleHTML(title: string): string {
  return title
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

// copied from: packages/sub-issues/utils/urls.ts
export const QUERY_FIELDS = {
  label: 'label',
  type: 'type',
  assignee: 'assignee',
} as const
// Returns the repository "scoped" issues search url for the provided metadata
// For example, this is used to generate the search url used when clicking on an issue type token
export const getIssueSearchURL = (
  {owner, repo}: {owner: string; repo: string},
  field: keyof typeof QUERY_FIELDS,
  value: string,
) => {
  if (!owner || !repo) {
    return ''
  }

  const baseUrl = `/${owner}/${repo}/issues`

  if (!field || !value) {
    return baseUrl
  }

  value = value.includes(' ') ? `"${value}"` : value
  const query = encodeURIComponent(`${field}:${value}`)
  return `${baseUrl}?q=${query}`
}

/**
 * Gathers issue link hrefs from a container element.
 *
 * Matches server-rendered issue links and React issue hovercard links.
 */
export function gatherIssueLinks(container: HTMLElement | null): string[] {
  if (!container) return []

  const issueLinks = container.querySelectorAll<HTMLAnchorElement>('a.issue-link, a[data-hovercard-type="issue"]')
  return Array.from(issueLinks).map(link => link.href)
}
